import { useQueryWithUserId } from '@northladder/services';

import { GOOGLE_MAPS_API } from '../googleMapsAPIClient';
import { GooglePlaceData } from '../types';

/**
 * Query to fetch Google Maps places based on a search key and language.
 * This is used to get the list of places from Google Maps API.
 */
export const useGoogleMapsPlacesQuery = (
  searchKey: string,
  language: 'en',
  enabled: boolean
) => {
  const queryKey = ['googleMapsPlaces', searchKey, language];
  const { data, isError, isFetching, isPending } = useQueryWithUserId<
    GooglePlaceData[],
    Error
  >({
    queryKey,
    queryFn: () => GOOGLE_MAPS_API.fetchPlaces(searchKey, language),
    enabled,
    staleTime: 1000 * 60 * 5, // 5 minutes
    retry: 1,
  });

  return {
    data,
    isError,
    isFetching,
    isPending: enabled && isPending,
  };
};
